import { Grid, TextField } from "@mui/material";
import React, { ChangeEvent } from "react";
import { ITaskTypeEditItem } from "source/models/taskType/taskTypeEditItem";
import { Dropdown, IDropdownAction } from "ui/Scripts/source/components/framework/Dropdown/Dropdown";
import { TaskLockingType, TaskVisibility } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { FormCheckBox } from "../../../framework/FormCheckBox";
import { FormField } from "../../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { GridRow } from "../../../framework/Grid/GridRow";

interface ITaskTypeDialogBasicInformationProps {
    code: string;
    comment: string;
    taskLockingType: TaskLockingType;
    printOrientationLandscape: boolean;
    visibility: TaskVisibility;
    activeState: number;
    item: ITaskTypeEditItem;
    isNew: boolean;
    onHandleChange: (event: ChangeEvent) => void;
    onUpdateTaskLockingType: (taskLockingType: TaskLockingType) => void;
    onUpdateVisibility: (visibility: TaskVisibility) => void;
    onUpdatePrintOrientationLandscape: (printOrientationLandscape: boolean) => void;
    onUpdateActiveState: (activeState: number) => void;
}

export const TaskTypeDialogBasicInformation = (props: ITaskTypeDialogBasicInformationProps) => {
    const getTaskLockingTypeText = (taskLockingType: TaskLockingType): string => {
        return taskLockingType === TaskLockingType.NoLocking
            ? Translations.NoLocking
            : Translations.LockTaskTypeAfterSave;
    };

    const getTaskLockingTypeAction = (taskLockingType: TaskLockingType): IDropdownAction => {
        return {
            title: getTaskLockingTypeText(taskLockingType),
            selected: props.taskLockingType === taskLockingType,
            onClick: () => props.onUpdateTaskLockingType(taskLockingType),
        };
    };

    const getVisibilityText = (visibility: TaskVisibility): string => {
        return visibility === TaskVisibility.Private
            ? Translations.Private
            : (visibility === TaskVisibility.Public
                ? Translations.Public
                : Translations.PrivateAndPublic);
    };

    const getVisibilityAction = (visibility: TaskVisibility): IDropdownAction => {
        return {
            title: getVisibilityText(visibility),
            selected: props.visibility === visibility,
            onClick: () => props.onUpdateVisibility(visibility),
        };
    };

    const getPrintOrientationText = (printOrientationLandscape: boolean): string => {
        return printOrientationLandscape
            ? Translations.Landscape
            : Translations.Portrait;
    };

    const getPrintOrientationAction = (printOrientationLandscape: boolean): IDropdownAction => {
        return {
            title: getPrintOrientationText(printOrientationLandscape),
            selected: props.printOrientationLandscape === printOrientationLandscape,
            onClick: () => props.onUpdatePrintOrientationLandscape(printOrientationLandscape),
        };
    };

    return <>
        <GridRow container>
            <Grid item sm={10}>
                <FormField title={Translations.Name} fullWidth required margin="0">
                    <TextField name="code" title={Translations.Code} inputProps={{
                        maxLength: 50
                    }} value={props.code} required={true} onChange={props.onHandleChange} size="small" fullWidth disabled={!props.isNew} autoFocus={props.isNew} />
                </FormField>
            </Grid>
            <Grid item sm={2}>
                <FormField fullWidth title={<span>&nbsp;</span>} margin="0">
                    <FormCheckBox title={Translations.InUse} checked={props.activeState > 0} onChange={(checked: boolean) => props.onUpdateActiveState(checked ? 1 : 0)} />
                </FormField>
            </Grid>
        </GridRow>
        <GridRow>
            <Grid item sm={12}>
                <FormField title={Translations.Description} fullWidth>
                    <TextField name="comment" title={Translations.Description} inputProps={{
                        maxLength: 1000
                    }} value={props.comment} onChange={props.onHandleChange} multiline rows={5} size="small" fullWidth />
                </FormField>
            </Grid>
        </GridRow>
        <GridRow>
            <Grid item sm={5}>
                <FormField title={Translations.TaskLockingType} fullWidth>
                    <Dropdown selectedTitle={getTaskLockingTypeText(props.taskLockingType)} selectMode={true} actions={[getTaskLockingTypeAction(TaskLockingType.NoLocking), getTaskLockingTypeAction(TaskLockingType.LockSavedForm)]} />
                </FormField>
            </Grid>
            <Grid item sm={4}>
                <FormField title={Translations.Visibility} fullWidth>
                    <Dropdown selectedTitle={getVisibilityText(props.visibility)} selectMode={true} actions={[getVisibilityAction(TaskVisibility.Private), getVisibilityAction(TaskVisibility.Public), getVisibilityAction(TaskVisibility.PrivateAndPublic)]} />
                </FormField>
            </Grid>
            <Grid item sm={3}>
                <FormField title={Translations.PrintOrientation} fullWidth>
                    <Dropdown selectedTitle={getPrintOrientationText(props.printOrientationLandscape)} selectMode={true} actions={[getPrintOrientationAction(false), getPrintOrientationAction(true)]} />
                </FormField>
            </Grid>
        </GridRow>
    </>;
};
